import { publish } from '@wh/message-bus'; //TODO change to @sb/message-bus once problem fixed with this package deploying and remove ts-ignore
import { whenAdapterReady } from './whenAdapterReady';
import { whenTrackCompleted } from './whenTrackCompleted';
import { ANALYTICS_TRACKING_TIMEOUT_MS, MB_EVENT_PARTIAL } from '../consts';
export const doTrack = ({ index, title }) => {
    return new Promise((resolve) => {
        const timeout = window.setTimeout(resolve, ANALYTICS_TRACKING_TIMEOUT_MS);
        const trackData = {
            event: 'widget_interactions_epic_value',
            payload: {
                EventAction: 'Epic Value',
                EventLabel: title ? title : null,
                ElementType: 'Standard',
                NavigationPosition: `${index}`,
            },
        };
        whenAdapterReady(() => {
            publish(MB_EVENT_PARTIAL, trackData);
            whenTrackCompleted({ resolve, trackData, timeout });
        });
    });
};
